import {
  Box,
  Button,
  Container,
  SelectChangeEvent,
} from "src/components/MuiGenerals";
import { customSx } from "src/utils/styling";
import ChainNameSingleSelection from "./components/ChainNameSingleSelection";
import CurrencySingleSelection from "./components/CurrencySingleSelection";
import ThresholdNumberTextField from "./components/ThresholdNumberTextField";
import { ChangeEvent } from "react";
import SpenderAddressSingleSelection from "./components/SpenderAddressSingleSelection";
import MaxNumberOfSweepableAddressesNumberTextField from "./components/MaxNumberOfSweepableAddressesNumberTextField";
import { useBatchContractSweepFormContext } from "../../contexts";
import LoadingDialog from "src/components/LoadingDialog";
import RiskTypeSingleSelection from "./components/RiskTypeSingleSelection";
import WalletSettlementTimePicker from "./components/WalletSettlementTimePicker";
import WalletVersionSingleSelection from "./components/WalletVersionSingleSelection";

function Filters() {
  const {
    fields,
    setFields,
    isLoading,
    onPreview,
    translate: t,
  } = useBatchContractSweepFormContext();

  const onChange =
    (fieldName: keyof typeof fields) =>
    (
      e:
        | SelectChangeEvent<string>
        | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
      setFields((prev) => ({ ...prev, [fieldName]: e.target.value }));
    };

  const canPreview = Object.entries(fields).every(
    ([key, value]) => value !== "" || key === "walletVersion",
  );

  return (
    <Box
      sx={{
        ...customSx.layoutBox,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1rem",
      }}>
      <LoadingDialog forceOpen={isLoading} />
      <Container disableGutters maxWidth={false} sx={customSx.gridFilter}>
        <ChainNameSingleSelection />
        <CurrencySingleSelection />
        <SpenderAddressSingleSelection
          value={fields.spenderAddress}
          onChange={onChange("spenderAddress")}
        />
        <RiskTypeSingleSelection />
        <ThresholdNumberTextField
          value={fields.threshold}
          onChange={onChange("threshold")}
        />
        <MaxNumberOfSweepableAddressesNumberTextField
          value={fields.maxNumberOfAddresses}
          onChange={onChange("maxNumberOfAddresses")}
        />
        <WalletSettlementTimePicker />
        <WalletVersionSingleSelection />
      </Container>

      <Button
        disabled={!canPreview}
        onClick={onPreview}
        // sx={sx.preview}
        color="secondary"
        variant="contained">
        {t("preview")}
      </Button>
    </Box>
  );
}

export default Filters;
